exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#general-layout[data-v-464692bf]{position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-464692bf","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/layouts/general/style.scss
// module id = 621
// module chunks = 0